'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useInterval = undefined;

var _react = require('react');

var useInterval = function useInterval(callback, delay, immediate) {
    var savedCallback = (0, _react.useRef)(function () {
        return;
    });
    (0, _react.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0, _react.useEffect)(function () {
        if (!immediate) {
            return;
        }
        if (delay === null) {
            return;
        }
        savedCallback.current();
    }, [delay, immediate]);
    (0, _react.useEffect)(function () {
        if (delay === null) {
            return undefined;
        }
        var tick = function tick() {
            return savedCallback.current();
        };
        var id = setInterval(tick, delay);
        return function () {
            return clearInterval(id);
        };
    }, [delay]);
};
exports.useInterval = useInterval;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/hooks/index.js
// module id = 1938
// module chunks = 0